import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse, ICmsNetworkMapStationInfoResponse, ICmsNetworkMapStationsResponse } from "../../Orchestrator/Types/Index";

export async function getCmsNetworkMapStations(): Promise<IApiResponse<ICmsNetworkMapStationsResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getNetworkMapStations;

  const params = new URLSearchParams({
    "populate[station][populate]": "image",
    "populate[popular_trips][fields][0]=": "name",
    "populate[popular_trips][fields][1]": "code",    
    locale: await getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsNetworkMapStationsResponse>(endpointWithParams, "GET");
}

export async function getCmsNetworkMapStationInfo(localeOverride?: string): Promise<IApiResponse<ICmsNetworkMapStationInfoResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getNetworkMapStationInfo;

  const params = new URLSearchParams({
    "populate[mobile_map]": "true",
    "populate[desktop_map]": "true",
    locale: localeOverride ?? getLocaleFromCookie()
  });

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsNetworkMapStationInfoResponse>(endpointWithParams, "GET");
}
